// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import LinkURL from './LinkURL';
import Icon from '../../components/icons/Icon';

// Styles
import './LinkHeader.scss';

const LinkHeader = (props) => {
    const { element } = props;

    const isLoaded = element.getIn(['content', 'link', 'url']);

    if (!isLoaded) return null;

    const favicon = element.getIn(['content', 'link', 'favicon']);

    const faviconElement = favicon ? <img className="favicon" src={favicon} /> : <Icon name="link-icon" />;

    return (
        <div className="LinkHeader">
            <div className="favicon-container">{faviconElement}</div>
            <LinkURL {...props} />
        </div>
    );
};

LinkHeader.propTypes = {
    element: PropTypes.object,
};

export default LinkHeader;
